import React from 'react'
import { WorkModel } from '@Entities/work/work'
import { mapRecordingToRecordingModel } from '@App/helpers/recording-to-recordingmodel'
import { formatName } from '@App/helpers/format-name'
import { WriterModel } from '@Entities/work/writer-model'
import { RecordingModel } from '@Entities/work/recording-model'

interface ExtendedWorkWriterFieldsProps {
    work: WorkModel
}

const ExtendedWorkWriterFields = ({ work }: ExtendedWorkWriterFieldsProps) => {
    const filteredWriters = work.writers
        ?.map((writer: WriterModel) => formatName(writer.firstName, writer.lastName, writer.fullName))
        .filter(Boolean)
    const recordingCount = work.submissionId ? work.recordings.length : (work.matchedRecordings?.count ?? 0)
    const recordingsToDisplay = work.submissionId
        ? (work.recordings ?? []).filter(Boolean)
        : (work.matchedRecordings?.recordings?.filter(Boolean).map(mapRecordingToRecordingModel) ?? [])
    const getNormalizedValue = (value: string | null | undefined) => value?.trim() ?? ''
    const uniqueRecordingTitles = Array.from(
        new Set(
            recordingsToDisplay.map((recording: RecordingModel) => getNormalizedValue(recording.title)).filter(Boolean)
        )
    )
    const uniqueArtistNames = Array.from(
        new Set(
            recordingsToDisplay
                .map((recording: RecordingModel) => getNormalizedValue(recording.artistName))
                .filter(Boolean)
        )
    )

    return (
        <>
            <div className="names-list">
                <div>Writers ({filteredWriters.length})</div>
                <div>{filteredWriters.join(', ')}</div>
            </div>
            <div className="names-list">
                <div>Recording Artists ({uniqueArtistNames.length})</div>
                <div>{uniqueArtistNames.join(', ')}</div>
            </div>
            <div className="names-list">
                <div>Recordings ({recordingCount ?? 0})</div>
                <div>{uniqueRecordingTitles.join(', ')}</div>
            </div>
        </>
    )
}

export default ExtendedWorkWriterFields
